import React, { useEffect } from "react";

const EnvironmentConstants = {
  LIVE_ENVIRONMENT: 0,
  STAGE_ENVIRONMENT: 1,
  LOCAL_ENVIRONMENT: 2,
  DEMO_ENVIRONMENT: 3,
  ARCHIVE_ENVIRONMENT: 10,
  UAT1_ENVIRONMENT: 30,
  UAT2_ENVIRONMENT: 31,
  LIVE_ENVIRONMENT_TEXT: "Live",
  LOCAL_ENVIRONMENT_TEXT: "Local",
  STAGE_ENVIRONMENT_TEXT: "Stage",
  ARCHIVE_ENVIRONMENT_TEXT: "Archive",
  DEMO_ENVIRONMENT_TEXT: "Demo",
  UAT1_ENVIRONMENT_TEXT: "Uat1",
  UAT2_ENVIRONMENT_TEXT: "Uat2",
};

const getServicesBaseUrl = () => {
  let echo_domain, merittoService, nodeLivechat,chatBot,npfBackend,npf,entityService;
  const currentEnvironment = process.env.REACT_APP_ENVIRONMENT;

  if (currentEnvironment == EnvironmentConstants.LIVE_ENVIRONMENT) {
    echo_domain = "https://echo.<infra>.nopaperforms.io";
    merittoService = "http://<institute_id>.<infra>.ms-service.prodnpf.internal";
    entityService = "http://<region>.entity-services.prodnpf.internal";
    nodeLivechat = "https://node.<infra>.nopaperforms.com";
    chatBot='https://<institute_id>.<infra>.chatbot-services.nopaperforms.in'
    npfBackend = "https://<institute_id>.<infra>.nopaperforms.io"
    npf = "https://<institute_id>.<infra>.nopaperforms.io"

    } else if (currentEnvironment == EnvironmentConstants.UAT1_ENVIRONMENT) {
      echo_domain = "https://chat.<infra>.nopaperforms.in";
    merittoService = "http://<institute_id>.<infra>.ms-service.stagenpf.internal";
    entityService = "http://<region>.uat.entity-services.stagenpf.internal";
    nodeLivechat = "https://node.<infra>.nopaperforms.in";
    chatBot='https://<institute_id>.<infra>.chatbot-services.nopaperforms.in'
    npfBackend = "https://<institute_id>.<infra>.nopaperforms.net"
    npf = "https://<institute_id>.<infra>.nopaperforms.net"

  } else if (currentEnvironment == EnvironmentConstants.UAT2_ENVIRONMENT) {
      echo_domain = "https://chat.<infra>.nopaperforms.in";
    merittoService = "http://<institute_id>.<infra>.ms-service.stagenpf.internal";
    entityService = "http://<region>.uat2.entity-services.stagenpf.internal";
    nodeLivechat = "https://node.<infra>.nopaperforms.in";
    chatBot='https://<institute_id>.<infra>.chatbot-services.nopaperforms.in'
    npfBackend = "https://<institute_id>.<infra>.nopaperforms.net"
    npf = "https://<institute_id>.<infra>.nopaperforms.net"
  }
   else {
      echo_domain = "https://chat.<infra>.nopaperforms.in";
    merittoService = "http://<institute_id>.<infra>.ms-service.stagenpf.internal";
    entityService = "http://<region>.<infra>.entity-services.stagenpf.internal";
    nodeLivechat = "https://node.<infra>.nopaperforms.in";
    chatBot='https://<institute_id>.<infra>.chatbot-services.nopaperforms.in'
    npfBackend = "https://<institute_id>.<infra>.nopaperforms.net"
    npf = "https://<institute_id>.<infra>.nopaperforms.net"

    if (currentEnvironment == EnvironmentConstants.LOCAL_ENVIRONMENT) {
      echo_domain = 'https://chat.<infra>.nopaperforms.in'
      merittoService = "http://<institute_id>.<infra>.ms-service.nopaperforms.in";
      entityService = "http://<region>.entity-services.nopaperforms.in";
      npfBackend = "https://<institute_id>.<infra>.nopaperforms.net"
      npf = "https://<institute_id>.<infra>.npf.net"
    }
  }

  const MERITTO_ALL_SERVICES = {
    ECHO_DOMAIN: echo_domain,
    NODE_LIVECHAT: nodeLivechat,
    MERITTO_SERVICES: merittoService,
    ENTITY_SERVICES: entityService,
    CHAT_BOT_URL:chatBot,
    NPF_BACKEND:npfBackend,
    NPF:npf
  };
  return MERITTO_ALL_SERVICES;
};

export const getBaseUrl = (micro_service, infra, region="",institute_id="") => {
  const services = getServicesBaseUrl();
  let services_base_url = services[micro_service];
  services_base_url = services_base_url.replace("<infra>", infra);
  if(institute_id){
    services_base_url = services_base_url.replace("<institute_id>",institute_id)
  }
  else{
    services_base_url = services_base_url.replace("<institute_id>.","")
  }
  if (region) {
    services_base_url = services_base_url.replace("<region>", region);
  }
  return services_base_url;
};
